<template>
    <div class="timesheet_info">
        <div class="ts_info" v-if="show_ts_info">
          <div id="company_information">
            <div class="row">
              <div class="col-12">
                <h3 class="bp_color">{{ ts_info.company_name }}</h3>
              </div>
              <div class="col-xl-6"><strong class="ci_label">Finance Ref : </strong>{{ ts_info.internal_finance_ref }}</div>
              <div class="col-xl-6"><strong class="ci_label">Invoicing Type : </strong>{{ ts_info.invoicing_type }}</div>
              <div class="col-xl-6"><strong class="ci_label">Payroll Solution : </strong>{{ ts_info.payroll_solution }}</div>
              <div class="col-xl-6">
                <strong class="ci_label">Fee Agreed with Company : </strong>
                <span v-if="ts_info.fee_margin_type === '£ (Pound)'">{{ ts_info.fee_margin_amount | currency }}</span>
                <span v-if="ts_info.fee_margin_type === '% (Percentage)'">{{ ts_info.fee_margin_amount | percentage }}</span>
              </div>
              <div class="col-12">&nbsp;</div>
              <div class="col-xl-4">
                <strong class="ci_label">Min VAT Percentage worked : </strong>
                <span>{{ ts_info.min_vat_percentage_worked_to }}</span>
              </div>
              <div class="col-xl-4"><strong class="ci_label">Timesheet Cycle : </strong>{{ ts_info.timesheet_cycle }}</div>
              <div class="col-xl-4"><strong class="ci_label">Pay Cycle : </strong>{{ ts_info.pay_cycle }}</div>
              <div class="col-xl-4"><strong class="ci_label">Week Start Day : </strong>{{ ts_info.pay_week_start_day }}</div>
              <div class="col-xl-4"><strong class="ci_label">Pay Instruction Day : </strong>{{ ts_info.pay_instruction_day }}</div>
              <div class="col-xl-4"><strong class="ci_label">Pay Client Payment Day : </strong>{{ ts_info.pay_client_payment_day }}</div>
<!--                <div class="col-xl-4"><strong class="ci_label">Pay Payment to worker : </strong>{{ ts_info.pay_worker_payment_day }} {{ ts_info.pay_worker_payment_time }}</div>-->
<!--                <div class="col-xl-4"><strong class="ci_label">Pay Worker Text Day : </strong>{{ ts_info.pay_worker_text_day }}</div>-->
            </div>
            <div class="row" v-if="check_company_info()">
              <div class="col-12 mt-3 mb-3">
                <h3 class="mb-0"><strong style="color: #dc3545; text-transform: uppercase;">Please ensure all company information is complete!</strong></h3>
                <p>You will be unable to pull any exports until the company record information is completed.</p>
              </div>
            </div>
            <div class="row mt-3" v-else>
              <!-- Payroll Export Button -->
              <div class="col-sm-6">
                <button
                        class="btn orcaBtn sm_btn w-100 purpleBtn mb-2" @click.prevent="payroll_export()" :disabled="p_export">
                  <span v-if="p_export"><i class="fas fa-spinner fa-spin"></i> Downloading Payroll Export</span>
                  <span v-else>Download Payroll Export <i v-if="this.company_records.payroll_exported">(exported)</i></span>
                </button>
              </div>
              <!-- Invoice Export Button -->
              <div class="col-sm-6">
                <button
                        class="btn orcaBtn sm_btn w-100 warning mb-2" @click.prevent="invoice_export()" :disabled="i_export">
                  <span v-if="i_export"><i class="fas fa-spinner fa-spin"></i> Downloading Invoice Export</span>
                  <span v-else>Download Invoice Export <i v-if="this.company_records.accounts_exported">(exported)</i></span>
                </button>
              </div>

              <div class="col-12">
                <hr class="mt-1">
              </div>
              <div class="col-sm-6">
                <button class="btn orcaBtn sm_btn w-100 blueBtn" @click.prevent="excel_export()" :disabled="e_export">
                  <span v-if="e_export"><i class="fas fa-spinner fa-spin"></i> Downloading Validation Export</span>
                  <span v-else>Download Validation Export</span>
                </button>
              </div>
              <div class="col-sm-6">
                <button class="btn orcaBtn sm_btn w-100 grey_bg" @click.prevent="excel_add_ded_export()" :disabled="ead_export">
                  <span v-if="ead_export"><i class="fas fa-spinner fa-spin"></i> Downloading Add/Ded Breakdown Export</span>
                  <span v-else>Download Add/Ded Breakdown Export</span>
                </button>
              </div>
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <h4 class="bp_color">Timesheets period: <span>{{ this.formatPeriodDate() }}</span>
                </h4>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                    <multiselect v-model="company_records.end_date" 
                                 id="change_submission_date" 
                                 name="change_submission_date"
                                 :options="company_records.submission_dates" 
                                 @select="changeCompanyDate"
                                 placeholder="">
                    </multiselect>
                    <label>Change submission date</label>
                </div>
            </div>
          </div>

          <div id="company_timesheets">
            <div class="row preview_workers mt-4">
              <div class="col-12">

                <div class="table-responsive mb-3" id="historic_per_worker_loc_table">
                  <table class="table table-striped table-sm">
                    <thead>
                    <tr>
                      <th scope="col" class="firstName">Name</th>
                      <th scope="col" style="min-width:150px;">Job Title</th>
                      <th scope="col" class="payRate" v-if="!recruitment">Pay/Rate Type</th>
                      <th scope="col" class="payRate" v-else>Charge/Rate Type</th>
                      <th scope="col" class="payRate" v-if="!recruitment">Pay Rate</th>
                      <th scope="col" class="payRate" v-else>Charge Rate</th>
                      <th scope="col" class="preview_sites" :style="'z-index: ' + zindexcalc(i)" v-for="(o, j, i) in locations">
                        <div><span>{{ j }} <span class="bp_color">
                         <br>
                        {{ formatSiteVatTreatmentList(o)}}
                        </span></span></div>
                
                      </th>
                      <th scope="col" class="add_ded_total_columns">Pre Tax Addition</th>
                      <th scope="col" class="add_ded_total_columns">Post Tax Addition</th>
                      <th scope="col" class="add_ded_total_columns">Pre Tax Deduction</th>
                      <th scope="col" class="add_ded_total_columns">Post Tax Deduction</th>
                      <th scope="col" class="add_ded_total_columns">Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="w in preview_rows">
                      <td class="firstName">
                        <div class="td_data_outer">
                          <div class="td_data">{{ w.first_name }} {{ w.surname }}</div>
                        </div>
                      </td>

                      <td class="">
                        <div class="td_data_outer">
                          <div class="td_data">{{ w.job_title }}</div>
                        </div>
                      </td>
                      <td>
                        <div class="td_data_outer">
                          <div class="td_data">{{ w.rate_type }}/{{ w.pay_type }}</div>
                        </div>
                      </td>
                      <td>
                        <div class="td_data_outer">
                          <div class="td_data" v-if="!recruitment">{{ w.pay_rate | currency }}</div>
                          <div class="td_data" v-else>{{ w.admin_fee_amount | currency }}</div>
                        </div>
                      </td>

                      <td v-for="(j, loc, er) in locations" class="preview_site_totals">
                        <div class="td_data_outer">
                          <div class="td_data">
                            {{ get_worker_site_total(w, loc) | currency }}
                          </div>
                        </div>
                      </td>
                      <td class="add_ded_total_columns">
                        <div class="td_data_outer">
                          <div class="td_data">{{ calc_worker_pre_tax_addition(w) | currency }}</div>
                        </div>
                      </td>
                      <td class="add_ded_total_columns">
                        <div class="td_data_outer">
                          <div class="td_data">{{ calc_worker_post_tax_addition(w) | currency }}</div>
                        </div>
                      </td>
                      <td class="add_ded_total_columns">
                        <div class="td_data_outer">
                          <div class="td_data">{{ calc_worker_pre_tax_deduction(w) | currency }}</div>
                        </div>
                      </td>
                      <td class="add_ded_total_columns">
                        <div class="td_data_outer">
                          <div class="td_data">{{ calc_worker_post_tax_deduction(w) | currency }}</div>
                        </div>
                      </td>
                      <td class="add_ded_total_columns">
                        <div class="td_data_outer">
                          <div class="td_data">
                            {{ get_worker_invoice_total(w) | currency }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                      <td class="running_totals">
                        <div class="td_data_outer">
                          <div class="td_data font-weight-bold">TOTALS</div>
                        </div>
                      </td>

                      <td>
                        <div class="td_data_outer">
                          <div class="td_data font-weight-bold"></div>
                        </div>
                      </td>
                      <td>
                        <div class="td_data_outer">
                          <div class="td_data font-weight-bold"></div>
                        </div>
                      </td>
                      <td>
                        <div class="td_data_outer">
                          <div class="td_data font-weight-bold"></div>
                        </div>
                      </td>

                      <td v-for="(j, loc, er) in locations" class="preview_site_totals">
                        <div class="td_data_outer">
                          <div class="td_data font-weight-bold">{{ calc_total_site_totals(loc) | currency }}</div>
                        </div>
                      </td>
                      <td class="add_ded_total_columns">
                        <div class="td_data_outer">
                          <div class="td_data font-weight-bold">{{ calc_total_pre_tax_addition() | currency }}</div>
                        </div>
                      </td>
                      <td class="add_ded_total_columns">
                        <div class="td_data_outer">
                          <div class="td_data font-weight-bold">{{ calc_total_post_tax_addition() | currency }}</div>
                        </div>
                      </td>
                      <td class="add_ded_total_columns">
                        <div class="td_data_outer">
                          <div class="td_data font-weight-bold">{{ calc_total_pre_tax_deduction() | currency }}</div>
                        </div>
                      </td>
                      <td class="add_ded_total_columns">
                        <div class="td_data_outer">
                          <div class="td_data font-weight-bold">{{ calc_total_post_tax_deduction() | currency }}</div>
                        </div>
                      </td>
                      <td class="add_ded_total_columns">
                        <div class="td_data_outer">
                          <div class="td_data font-weight-bold">{{ calc_total_invoice_total() | currency }}</div>
                        </div>
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <loadingCube :loadingMessage="'TIMESHEET SUBMISSION'"></loadingCube>
        </div>
    </div>
</template>

<script>
import datatable from "datatables/datatable";
import loadingCube from "loaders/record_loader";
import Datepicker from 'vuejs-datepicker';
import Multiselect from "vue-multiselect";

export default {
  name: "submitted_timesheets",
  components: {
    datatable,
    loadingCube,
    Datepicker,
    Multiselect
  },
  data() {
    return {
      company_list: [],
      company_records: [],
      timesheets: [],
      ts_info: [],
      ts_info_company_index: null,
      show_ts_info: false,
      p_export: false,
      i_export: false,
      e_export: false,
      ead_export: false,
      movingTimesheets: false,
      ts_records: [],
      preview_rows: [],
      order_jobs: [],
      locations: [],
      recruitment: false,
      week: {},
      show_timesheets: false,
      moveTimesheetsDate: this.dateFormat(new Date(), 'YYYY-MM-DD'),
      axios_cancel_token: null
    }
  },
  mounted() {
    let company_id = this.$route.query.company;
    let date = this.$route.query.date;
    this.show_company(company_id, date);
  },
  methods: {
    formatSiteVatTreatmentList(data) {
      const uniqueValues = [...new Set(data.map(item => item.site_vat_treatment))];
      return uniqueValues.map(value => this.percentageSign(value)).join(', ');
    },
    percentageSign(value) {
      return value + '%';
    },
    dateFormat(date, format = 'DD/MM/YYYY') {
      return this.$moment(date).format(format);
    },
    formatPeriodDate() {
      let sDate = this.dateFormat(this.company_records.start_date);
      let eDate = this.dateFormat(this.company_records.end_date);
      
      return sDate + ' - ' + eDate;  
    },
    changeCompanyDate(date) {
        this.show_company(this.company_records.company_info.id, date);
    },
    // Individual company functions ======================================================================
    show_company(id, date) {
      if (this.axios_cancel_token !== null) {
        this.axios_cancel_token.cancel();
      }
      this.company_records = [];
      this.axios_cancel_token = axios.CancelToken.source();
      this.show_timesheets = false;
      this.show_ts_info = false;
      this.ts_info_company_index = false;
      this.ts_info = [];
      this.ts_records = [];
      this.preview_rows = [];
      this.order_jobs = [];
      this.locations = [];
      this.recruitment = false;
      this.week = {};
      //
      axios.get(this.crmApiPath + 'timesheet/submitted/company/' + id + '/' + date, {
        cancelToken: this.axios_cancel_token.token
      }).then(info => {
        
        if(info.data.length === 0) {
          return;
        }

        this.company_records = info.data;
        let weeks = this.company_records.ts_records[0].timesheet_pay;
        let weekLength = weeks.length;
        
        for (let i = 0; i < weekLength; i++) {
              this.week[i] = this.$moment(weeks[i].pay_date).format('dddd DD/MM/YYYY')
        }

        setTimeout(() => {
          this.$nextTick(() => {
            this.ts_info = this.company_records.company_info;
            this.ts_records = this.company_records.ts_records;
            this.order_jobs = this.company_records.order_jobs;
            this.locations = this.company_records.locations;

            this.company_records.company_info.rel_contacts.forEach(element => {
              if (element.user !== null && element.user.recruitment) {
                this.recruitment = true;
              }
            });

            new Promise(resolve => {
              let length = Object.keys(this.company_records.ts_records).length;
              let count = 0;
              Object.values(this.company_records.ts_records).forEach(r => {

                  if (!this.preview_rows.some(e => e.worker_id === r.worker_id)) {
                    let add_pre_tax = [], add_post_tax = [], ded_pre_tax = [], ded_post_tax = [];
                    if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29).length > 0) {
                      add_pre_tax = r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29)
                    }
                    if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30).length > 0) {
                      add_post_tax = r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30)
                    }
                    if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31).length > 0) {
                      ded_pre_tax = r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31)
                    }
                    if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32).length > 0) {
                      ded_post_tax = r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32)
                    }
                    // check if limited company for finance ref used
                    let ifr = r.internal_finance_ref;
                    if (r.employment_type_id === 32 && r.company_internal_finance_ref !== null) {
                      ifr = r.company_internal_finance_ref;
                    }
                    this.preview_rows.push({
                      'worker_id': r.worker_id,
                      'first_name': r.first_name,
                      'surname': r.surname,
                      'genius_submitted': r.company_submitted,
                      'internal_finance_ref': ifr,
                      'job_title': null,
                      'pay_type': null,
                      'rate_type': null,
                      'pay_rate': null,
                      'admin_fee_amount': null,
                      [r.order_job_id]: {
                        'addition_pre_tax': add_pre_tax,
                        'addition_post_tax': add_post_tax,
                        'deduction_pre_tax': ded_pre_tax,
                        'deduction_post_tax': ded_post_tax,
                        'timesheet_pay': r.timesheet_pay,
                        'total_units': r.total_hours,
                        'total_before_additions_deductions': r.total_price,
                        'retention_amount': r.retention_amount,
                        'invoice_total': r.total_pay_amount,
                        //
                        'job_title': r.order_job.rel_order_position.job_title,
                        'pay_type': r.assignment.position_rate.pay_type,
                        'rate_type': r.assignment.position_rate.rate_type,
                        'pay_rate': r.assignment.position_rate.pay_amount,
                        'admin_fee_amount': r.assignment.position_rate.admin_fee_amount,
                        'location': r.order_job.rel_order_location.job_address_full,
                      }
                    })
                  }
                  else {
                    let existing = this.preview_rows.find(pr => pr.worker_id === r.worker_id);

                    if (existing.worker_id === r.worker_id) {
                      if (!r.company_submitted) {
                        existing.genius_submitted = r.company_submitted;
                      }
                    }

                    if (!(r.order_job_id in existing)) {
                      let add_pre_tax = [], add_post_tax = [], ded_pre_tax = [], ded_post_tax = [];
                      if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29).length > 0) {
                        add_pre_tax = r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29)
                      }
                      if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30).length > 0) {
                        add_post_tax = r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30)
                      }
                      if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31).length > 0) {
                        ded_pre_tax = r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31)
                      }
                      if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32).length > 0) {
                        ded_post_tax = r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32)
                      }

                      existing[r.order_job_id] = {
                        'addition_pre_tax': add_pre_tax,
                        'addition_post_tax': add_post_tax,
                        'deduction_pre_tax': ded_pre_tax,
                        'deduction_post_tax': ded_post_tax,
                        'timesheet_pay': r.timesheet_pay,
                        'total_units': r.total_hours,
                        'total_before_additions_deductions': r.total_price,
                        'retention_amount': r.retention_amount,
                        'invoice_total': r.total_pay_amount,
                        //
                        'job_title': r.order_job.rel_order_position.job_title,
                        'pay_type': r.assignment.position_rate.pay_type,
                        'rate_type': r.assignment.position_rate.rate_type,
                        'pay_rate': r.assignment.position_rate.pay_amount,
                        'admin_fee_amount': r.assignment.position_rate.admin_fee_amount,
                        'location': r.order_job.rel_order_location.job_address_full,
                      }
                    }
                    else {
                      if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29).length > 0) {
                        existing[r.order_job_id].addition_pre_tax.push(r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29));
                      }
                      if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30).length > 0) {
                        existing[r.order_job_id].addition_post_tax.push(r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30));
                      }
                      if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31).length > 0) {
                        existing[r.order_job_id].deduction_pre_tax.push(r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31));
                      }
                      if (r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32).length > 0) {
                        existing[r.order_job_id].deduction_post_tax.push(r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32));
                      }
                      existing[r.order_job_id].timesheet_pay.concat(r.timesheet_pay);
                      existing[r.order_job_id].total_units += r.total_hours;
                      existing[r.order_job_id].total_before_additions_deductions += r.total_price;
                      existing[r.order_job_id].retention_amount += r.retention_amount;
                      existing[r.order_job_id].invoice_total += r.total_pay_amount;
                    }
                  }
               
                count++;
                if (count === length) {
                  // loop per worker day array to check if job_title, pay type, rate type and pay rate are all the same
                  for (let j = 0; j < this.preview_rows.length; j++) {
                    for (let key in this.preview_rows[j]) {
                      if (key !== 'first_name' && key !== 'internal_finance_ref'
                          && key !== 'surname' && key !== 'worker_id'
                          && key !== 'job_title' && key !== 'pay_type'
                          && key !== 'rate_type' && key !== 'pay_rate' && key !== 'genius_submitted' && key !== 'admin_fee_amount') {
                        // job title
                        if (this.preview_rows[j].job_title === null) {
                          this.preview_rows[j].job_title = this.preview_rows[j][key].job_title;
                        }
                        else if (this.preview_rows[j].job_title !== this.preview_rows[j][key].job_title) {
                          this.preview_rows[j].job_title = false;
                        }
                        // pay type
                        if (this.preview_rows[j].pay_type === null) {
                          this.preview_rows[j].pay_type = this.preview_rows[j][key].pay_type;
                        }
                        else if (this.preview_rows[j].pay_type !== this.preview_rows[j][key].pay_type) {
                          this.preview_rows[j].pay_type = false;
                        }
                        // rate type
                        if (this.preview_rows[j].rate_type === null) {
                          this.preview_rows[j].rate_type = this.preview_rows[j][key].rate_type;
                        }
                        else if (this.preview_rows[j].rate_type !== this.preview_rows[j][key].rate_type) {
                          this.preview_rows[j].rate_type = false;
                        }
                        // pay rate
                        if (this.preview_rows[j].pay_rate === null) {
                          this.preview_rows[j].pay_rate = this.preview_rows[j][key].pay_rate;
                        }
                        else if (this.preview_rows[j].pay_rate !== this.preview_rows[j][key].pay_rate) {
                          this.preview_rows[j].pay_rate = false;
                        }
                        if (this.preview_rows[j].admin_fee_amount === null) {
                          this.preview_rows[j].admin_fee_amount = this.preview_rows[j][key].admin_fee_amount;
                        }
                        else if (this.preview_rows[j].admin_fee_amount !== this.preview_rows[j][key].admin_fee_amount) {
                          this.preview_rows[j].admin_fee_amount = false;
                        }
                      }
                    }
                  }
                  // Sort per worker day array first by job title and then surname and then first_name
                  this.preview_rows.sort(function (a, b) {
                    let surname_a = a.surname.toLowerCase(), surname_b = b.surname.toLowerCase(),
                        first_name_a = a.first_name.toLowerCase(), first_name_b = b.first_name.toLowerCase();
                    if (surname_a < surname_b) {
                      return -1
                    }
                    if (surname_a > surname_b) {
                      return 1
                    }
                    if (first_name_a < first_name_b) {
                      return -1
                    }
                    if (first_name_a > first_name_b) {
                      return 1
                    }
                  });
                  resolve()
                }
              })
            }).then(() => {
              this.$nextTick(() => {
                this.show_ts_info = true;
                this.$nextTick(() => {
                  // this.axios_cancel_token = null;
                  document.getElementById("company_timesheets").style.paddingTop = parseFloat(document.getElementById('company_information').offsetHeight) + "px";
                });
              })
            })
          })
        }, 500)
      });
    },

    check_company_info() {
      return this.ts_info.internal_finance_ref === null ||
          this.ts_info.invoicing_type === null ||
          this.ts_info.payroll_solution === null ||
          this.ts_info.fee_margin_amount === null ||
          this.ts_info.fee_margin_type === null ||
          this.ts_info.min_vat_percentage_worked_to === null ||
          this.ts_info.pay_cycle === null ||
          this.ts_info.timesheet_cycle === null ||
          this.ts_info.pay_week_start_day === null ||
          this.ts_info.pay_instruction_day === null ||
          this.ts_info.pay_client_payment_day === null
    },

    // Preview table functions ======================================================================
    zindexcalc(index) {
      return 80 - index;
    },

    get_worker_site_total(worker, o) {
      let site_total = 0;
      for (let [key, value] of Object.entries(this.locations)) {
        if (key === o) {
          for (let [k, v] of Object.entries(this.locations[key])) {
            if (worker.hasOwnProperty(v.order_job_id)) {
              site_total += worker[v.order_job_id].total_before_additions_deductions
            }
          }
        }
      }
      return site_total;
    },
    calc_worker_pre_tax_addition(worker) {
      let addition_pre_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type' && key !== 'admin_fee_amount') {
          for (let i = 0; i < worker[key].addition_pre_tax.length; i++) {
            if (Array.isArray(worker[key].addition_pre_tax[i])) {
              for (let j = 0; j < worker[key].addition_pre_tax[i].length; j++) {
                addition_pre_tax += worker[key].addition_pre_tax[i][j].amount;
              }
            } else {
              addition_pre_tax += worker[key].addition_pre_tax[i].amount;
            }
          }
        }
      }
      return addition_pre_tax;
    },
    calc_worker_post_tax_addition(worker) {
      let addition_post_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type' && key !== 'admin_fee_amount') {
          for (let i = 0; i < worker[key].addition_post_tax.length; i++) {
            if (Array.isArray(worker[key].addition_post_tax[i])) {
              for (let j = 0; j < worker[key].addition_post_tax[i].length; j++) {
                addition_post_tax += worker[key].addition_post_tax[i][j].amount;
              }
            } else {
              addition_post_tax += worker[key].addition_post_tax[i].amount;
            }
          }
        }
      }
      return addition_post_tax;
    },
    calc_worker_pre_tax_deduction(worker) {
      let deduction_pre_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type' && key !== 'admin_fee_amount') {
          for (let i = 0; i < worker[key].deduction_pre_tax.length; i++) {
            if (Array.isArray(worker[key].deduction_pre_tax[i])) {
              for (let j = 0; j < worker[key].deduction_pre_tax[i].length; j++) {
                deduction_pre_tax += worker[key].deduction_pre_tax[i][j].amount;
              }
            } else {
              deduction_pre_tax += worker[key].deduction_pre_tax[i].amount;
            }
          }
        }
      }
      return deduction_pre_tax;
    },
    calc_worker_post_tax_deduction(worker) {
      let deduction_post_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type' && key !== 'admin_fee_amount') {
          for (let i = 0; i < worker[key].deduction_post_tax.length; i++) {
            if (Array.isArray(worker[key].deduction_post_tax[i])) {
              for (let j = 0; j < worker[key].deduction_post_tax[i].length; j++) {
                deduction_post_tax += worker[key].deduction_post_tax[i][j].amount;
              }
            } else {
              deduction_post_tax += worker[key].deduction_post_tax[i].amount;
            }
          }
        }
      }
      return deduction_post_tax;
    },
    get_worker_invoice_total(worker) {
      let invoice_total = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type' && key !== 'admin_fee_amount') {
          invoice_total += worker[key].invoice_total;
        }
      }
      return invoice_total;
    },

    calc_total_site_totals(o) {
      let total = 0;
      for (let [key, value] of Object.entries(this.locations)) {
        if (key === o) {
          for (let [k, v] of Object.entries(this.locations[key])) {
            for (let i = 0; i < this.preview_rows.length; i++) {
              if (this.preview_rows[i].hasOwnProperty(v.order_job_id)) {
                total += this.preview_rows[i][v.order_job_id].total_before_additions_deductions;
              }
            }

          }
        }
      }
      return total;
    },
    calc_total_pre_tax_addition() {
      let total = 0;
      for (let i = 0; i < this.preview_rows.length; i++) {
        for (let key in this.preview_rows[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
              && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type' && key !== 'admin_fee_amount') {
            for (let k = 0; k < this.preview_rows[i][key].addition_pre_tax.length; k++) {
              if (Array.isArray(this.preview_rows[i][key].addition_pre_tax[k])) {
                for (let h = 0; h < this.preview_rows[i][key].addition_pre_tax[k].length; h++) {
                  total += this.preview_rows[i][key].addition_pre_tax[k][h].amount;
                }
              } else {
                total += this.preview_rows[i][key].addition_pre_tax[k].amount;
              }
            }
          }
        }
      }
      return total;
    },
    calc_total_post_tax_addition() {
      let total = 0;
      for (let i = 0; i < this.preview_rows.length; i++) {
        for (let key in this.preview_rows[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
              && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type' && key !== 'admin_fee_amount') {
            for (let k = 0; k < this.preview_rows[i][key].addition_post_tax.length; k++) {
              if (Array.isArray(this.preview_rows[i][key].addition_post_tax[k])) {
                for (let h = 0; h < this.preview_rows[i][key].addition_post_tax[k].length; h++) {
                  total += this.preview_rows[i][key].addition_post_tax[k][h].amount;
                }
              } else {
                total += this.preview_rows[i][key].addition_post_tax[k].amount;
              }
            }
          }
        }
      }
      return total;
    },
    calc_total_pre_tax_deduction() {
      let total = 0;
      for (let i = 0; i < this.preview_rows.length; i++) {
        for (let key in this.preview_rows[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
              && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type' && key !== 'admin_fee_amount') {
            for (let k = 0; k < this.preview_rows[i][key].deduction_pre_tax.length; k++) {
              if (Array.isArray(this.preview_rows[i][key].deduction_pre_tax[k])) {
                for (let h = 0; h < this.preview_rows[i][key].deduction_pre_tax[k].length; h++) {
                  total += this.preview_rows[i][key].deduction_pre_tax[k][h].amount;
                }
              } else {
                total += this.preview_rows[i][key].deduction_pre_tax[k].amount;
              }
            }
          }
        }
      }
      return total;
    },
    calc_total_post_tax_deduction() {
      let total = 0;
      for (let i = 0; i < this.preview_rows.length; i++) {
        for (let key in this.preview_rows[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
              && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type' && key !== 'admin_fee_amount') {
            for (let k = 0; k < this.preview_rows[i][key].deduction_post_tax.length; k++) {
              if (Array.isArray(this.preview_rows[i][key].deduction_post_tax[k])) {
                for (let h = 0; h < this.preview_rows[i][key].deduction_post_tax[k].length; h++) {
                  total += this.preview_rows[i][key].deduction_post_tax[k][h].amount;
                }
              } else {
                total += this.preview_rows[i][key].deduction_post_tax[k].amount;
              }
            }
          }
        }
      }
      return total;
    },
    calc_total_invoice_total() {
      let preview_invoice_total = 0;
      for (let i = 0; i < this.preview_rows.length; i++) {
        for (let key in this.preview_rows[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
              && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type' && key !== 'admin_fee_amount') {
            preview_invoice_total += this.preview_rows[i][key].invoice_total;
          }
        }
      }
      return preview_invoice_total;
    },

    // Download Payroll ======================================================================
    payroll_export() {
      this.p_export = true
      // Payroll crm Genius Company
      let payment_company = null;
      if (this.ts_info.payroll_trading_company === 'Genius Contracts Limited') {
        payment_company = 'contracts'
      }
      else if (this.ts_info.payroll_trading_company === 'Genius Payroll Limited') {
        payment_company = 'payroll'
      }

      axios.post(this.crmApiPath + 'timesheet/submitted/export/payroll_payments', {
        company_id: this.ts_info.id,
        payroll_company: payment_company,
        company_fee_type: this.ts_info.fee_margin_type,
        company_fee_amount: this.ts_info.fee_margin_amount,
        ts_records: this.ts_records
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Sage_Payroll_Payments-' + this.ts_info.company_name + '-' + this.$moment().format('DD-MM-YYYY') + '.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.company_records.payroll_exported = true;

        axios.post(this.crmApiPath + 'timesheet/submitted/export/payroll_deductions', {
          company_id: this.ts_info.id,
          payroll_company: payment_company,
          ts_records: this.ts_records
        }).then(response => {
          const url2 = window.URL.createObjectURL(new Blob([response.data]));
          const link2 = document.createElement('a');
          link2.href = url2;
          link2.setAttribute('download', 'Sage_Payroll_Deductions-' + this.ts_info.company_name + '-' + this.$moment().format('DD-MM-YYYY') + '.csv');
          document.body.appendChild(link2);
          link2.click();
          link2.remove();

          axios.post(this.crmApiPath + 'timesheet/submitted/export/mark/payroll', {
            company_id: this.ts_info.id,
            ts_records: this.ts_records
          }).then(() => {
            this.p_export = false;
          });

        });
      });
    },

    // Download Invoice ======================================================================
    invoice_export() {
      this.i_export = true;
      let num_sites = Object.keys(this.locations).length,
          vat = {
            vat_20: false,
            vat_5: false,
            vat_0: false,
            vat_20_rc: false,
            vat_5_rc: false
          },
          vat_20_sites = [],
          vat_5_sites = [],
          vat_0_sites = [],
          vat_20_rc_sites = [],
          vat_5_rc_sites = []
      if (this.ts_info.payroll_solution === 'Standard Payroll') {
        for (const [site, order_jobs] of Object.entries(this.locations)) {
          for (let i = 0; i < Object.keys(order_jobs).length; i++) {
           if((order_jobs[i].reverse_charge === 1)) {
                  vat.vat_20_rc = true;
                  vat_20_rc_sites.push(order_jobs[i].order_job_id);
              } else {
                  vat.vat_20 = true;
                  vat_20_sites.push(order_jobs[i].order_job_id)
              }
          }
        }
      }
      else if (this.ts_info.payroll_solution === 'Project Managed Labour Solutions') {
        for (const [site, order_jobs] of Object.entries(this.locations)) {
          for (let i = 0; i < Object.keys(order_jobs).length; i++) {
            if (order_jobs[i].site_vat_treatment === 20) {
              if((order_jobs[i].reverse_charge === 1)) {
                  vat.vat_20_rc = true;
                  vat_20_rc_sites.push(order_jobs[i].order_job_id);
              } else {
                  vat.vat_20 = true;
                  vat_20_sites.push(order_jobs[i].order_job_id)
              }
            }
            else if (order_jobs[i].site_vat_treatment === 5) {
              if((order_jobs[i].reverse_charge === 1)) {
                  vat.vat_5_rc = true;
                  vat_5_rc_sites.push(order_jobs[i].order_job_id);
              } else {
                  vat.vat_5 = true;
                  vat_5_sites.push(order_jobs[i].order_job_id)
              }
            }
            else if (order_jobs[i].site_vat_treatment === 0) {
              vat.vat_0 = true;
              vat_0_sites.push(order_jobs[i].order_job_id)
            }
          }
        }
      }
     
      if (this.ts_info.invoicing_type === 'vat - sites one line - plus additions' ||
          this.ts_info.invoicing_type === 'vat - sites per line - plus additions' ||
          this.ts_info.invoicing_type === 'vat - sites - plus additions') {

        // whether the line on an invoice is the worker's name or the site name
        let line_type = 'worker';
        if (this.ts_info.invoicing_type === 'vat - sites - plus additions') {
          line_type = 'sites';
        }
        
        let invoice_promises = [];
        for (const key in vat) {
          if (key === 'vat_20') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_invoice(this.ts_info, '20%', vat_20_sites, line_type, null).then(() => {
                  this.export_deductions_credit(this.ts_info, '20%', vat_20_sites, line_type, null).then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
          if (key === 'vat_20_rc') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_invoice(this.ts_info, '20%_RC', vat_20_rc_sites, line_type, null).then(() => {
                  this.export_deductions_credit(this.ts_info, '20%_RC', vat_20_rc_sites, line_type, null).then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
          if (key === 'vat_5') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_invoice(this.ts_info, '5%', vat_5_sites, line_type, null).then(() => {
                  this.export_deductions_credit(this.ts_info, '5%', vat_5_sites, line_type, null).then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
          if (key === 'vat_5_rc') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_invoice(this.ts_info, '5%_RC', vat_5_rc_sites, line_type, null).then(() => {
                  this.export_deductions_credit(this.ts_info, '5%_RC', vat_5_rc_sites, line_type, null).then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
          if (key === 'vat_0') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_invoice(this.ts_info, '0%', vat_0_sites, line_type, null).then(() => {
                  this.export_deductions_credit(this.ts_info, '0%', vat_0_sites, line_type, null).then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
        }
        Promise.all(invoice_promises).then(() => {
          this.company_records.accounts_exported = true;
          this.$nextTick(() => {
            this.i_export = false;
          });
        });
      }
      else if (this.ts_info.invoicing_type === 'vat - sites one line - extra additions' ||
          this.ts_info.invoicing_type === 'vat - sites per line - extra additions' ||
          this.ts_info.invoicing_type === 'vat - sites - extra additions') {
        // whether the line on an invoice is the worker's name or the site name
        
        let line_type = 'worker';
        if (this.ts_info.invoicing_type === 'vat - sites - extra additions') {
          line_type = 'sites';
        }

        let invoice_promises = [];
        for (const key in vat) {
          if (key === 'vat_20') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_invoice(this.ts_info, '20%', vat_20_sites, line_type, null).then(() => {
                  this.export_additions_invoice(this.ts_info, '20%', vat_20_sites, line_type, null).then(() => {
                    this.export_deductions_credit(this.ts_info, '20%', vat_20_sites, line_type, null).then(() => {
                      resolve();
                    })
                  })
                });
              }));
            }
          }
          if (key === 'vat_20_rc') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_invoice(this.ts_info, '20%_RC', vat_20_rc_sites, line_type, null).then(() => {
                  this.export_deductions_credit(this.ts_info, '20%_RC', vat_20_rc_sites, line_type, null).then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
          if (key === 'vat_5') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_invoice(this.ts_info, '5%', vat_5_sites, line_type, null).then(() => {
                  this.export_additions_invoice(this.ts_info, '5%', vat_5_sites, line_type, null).then(() => {
                    this.export_deductions_credit(this.ts_info, '5%', vat_5_sites, line_type, null).then(() => {
                      resolve();
                    })
                  })
                });
              }));
            }
          }
          if (key === 'vat_5_rc') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_invoice(this.ts_info, '5%_RC', vat_5_rc_sites, line_type, null).then(() => {
                  this.export_deductions_credit(this.ts_info, '5%_RC', vat_5_rc_sites, line_type, null).then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
          if (key === 'vat_0') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_invoice(this.ts_info, '0%', vat_0_sites, line_type, null).then(() => {
                  this.export_additions_invoice(this.ts_info, '0%', vat_0_sites, line_type, null).then(() => {
                    this.export_deductions_credit(this.ts_info, '0%', vat_0_sites, line_type, null).then(() => {
                      resolve();
                    })
                  })
                });
              }));
            }
          }
        }
        Promise.all(invoice_promises).then(() => {
          this.company_records.accounts_exported = true;
          this.$nextTick(() => {
            this.i_export = false;
          });
        });
      }
      else if (this.ts_info.invoicing_type === 'sites') {
        
        let line_type = 'worker';
        let invoice_promises = [];

        for (const [site, order_jobs] of Object.entries(this.locations)) {
          
          // try obtain short site name, if empty use 15 characters from full address
          let site_name = order_jobs[0].short_site_name ?? (site.substring(0, 15 + '__'));
          let order_jobs_20 = [];
          let order_jobs_20_rc = [];
          let order_jobs_5 = [];
          let order_jobs_5_rc = [];
          let order_jobs_0 = [];

          for (let i = 0; i < Object.keys(order_jobs).length; i++) {
            let order_job = order_jobs[i];
            
            switch(order_job.site_vat_treatment) {
                case 20:
                  if(order_job.reverse_charge === 1) {
                    order_jobs_20_rc.push(order_job.order_job_id);
                  } else {
                    order_jobs_20.push(order_job.order_job_id);
                  }
                  break;
                case 5:
                  if(order_job.reverse_charge === 1) {
                    order_jobs_5_rc.push(order_job.order_job_id);
                  } else {
                    order_jobs_5.push(order_job.order_job_id);
                  }
                  break;
                case 0:
                  order_jobs_0.push(order_job.order_job_id);
                  break;
            } 
          }

          // 20% VAT
          if(order_jobs_20.length > 0) {
              this.export_invoice(this.ts_info, '20%', order_jobs_20, line_type, site_name);
          }

          // 20% VAT Reverse Charge
          if(order_jobs_20_rc.length > 0) {
              this.export_invoice(this.ts_info, '20%_RC', order_jobs_20_rc, line_type, site_name);
          }

          // 5% VAT
          if(order_jobs_5.length > 0) {
              this.export_invoice(this.ts_info, '5%', order_jobs_5, line_type, site_name);
          }

          // 5% VAT Reverse Charge
          if(order_jobs_5_rc.length > 0) {
              this.export_invoice(this.ts_info, '5%_RC', order_jobs_5_rc, line_type, site_name);
          }

          // 0% VAT (reverse charge not applicable)
          if(order_jobs_0.length > 0) {
              this.export_invoice(this.ts_info, '0%', order_jobs_0, line_type, site_name);
          }

        }

        for (const key in vat) {
          if (key === 'vat_20') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_additions_invoice(this.ts_info, '20%', vat_20_sites, line_type, 'Sites').then(() => {
                  this.export_deductions_credit(this.ts_info, '20%', vat_20_sites, line_type, 'Sites').then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
          if (key === 'vat_20_rc') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_additions_invoice(this.ts_info, '20%_RC', vat_20_rc_sites, line_type, 'Sites').then(() => {
                  this.export_deductions_credit(this.ts_info, '20%_RC', vat_20_rc_sites, line_type, 'Sites').then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
          if (key === 'vat_5') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_additions_invoice(this.ts_info, '5%', vat_5_sites, line_type, 'Sites').then(() => {
                  this.export_deductions_credit(this.ts_info, '5%', vat_5_sites, line_type, 'Sites').then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
          if (key === 'vat_5_rc') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_additions_invoice(this.ts_info, '5%_RC', vat_5_rc_sites, line_type, 'Sites').then(() => {
                  this.export_deductions_credit(this.ts_info, '5%_RC', vat_5_rc_sites, line_type, 'Sites').then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
          if (key === 'vat_0') {
            if (vat[key] === true) {
              invoice_promises.push(new Promise(resolve => {
                this.export_additions_invoice(this.ts_info, '0%', vat_0_sites, line_type, 'Sites').then(() => {
                  this.export_deductions_credit(this.ts_info, '0%', vat_0_sites, line_type, 'Sites').then(() => {
                    resolve();
                  })
                });
              }));
            }
          }
        }
        Promise.all(invoice_promises).then(() => {
          this.company_records.accounts_exported = true;
          this.$nextTick(() => {
            this.i_export = false;
          });
        })
      }
    },

    // Download INVOICES ======================================================================

    export_invoice(ts_info, vat, order_jobs, line_type, short_site_name) {
      let payment_company = null;

      if (ts_info.payroll_trading_company === 'Genius Contracts Limited') {
        payment_company = 'contracts'
      }
      else if (ts_info.payroll_trading_company === 'Genius Payroll Limited') {
        payment_company = 'payroll'
      }
      
      let ts_record = this.ts_records[0];
      let ts_for_week_ending = [ts_record.for_work_end_week_date];

      return axios.get(this.crmApiPath + 'timesheet/submitted/export/invoice', {
        params: {
          company_id: ts_info.id,
          invoice_type: ts_info.invoicing_type,
          sage_ref: ts_info.internal_finance_ref,
          vat: vat,
          sites: order_jobs,
          gm_solution: ts_info.payroll_solution,
          payroll_company: payment_company,
          line_type: line_type,
          ts_for_week_ending: ts_for_week_ending,
          short_site_name: short_site_name,
          submitted_week_end: this.company_records.end_date
        }
      }).then(response => {
        if (response.data !== "") {
          this.download_file(response.data, ts_info.company_name, ts_info.invoicing_type, vat, short_site_name);
        }
      });
    },

    export_additions_invoice(ts_info, vat, order_jobs, line_type, short_site_name) {
      let payment_company = null;
      if (ts_info.payroll_trading_company === 'Genius Contracts Limited') {
        payment_company = 'contracts'
      }
      else if (ts_info.payroll_trading_company === 'Genius Payroll Limited') {
        payment_company = 'payroll'
      }

      let ts_record = this.ts_records[0];
      let ts_for_week_ending = [ts_record.for_work_end_week_date];

      return axios.get(this.crmApiPath + 'timesheet/submitted/export/additions_invoice', {
        params: {
          company_id: ts_info.id,
          invoice_type: ts_info.invoicing_type,
          sage_ref: ts_info.internal_finance_ref,
          vat: vat,
          sites: order_jobs,
          gm_solution: ts_info.payroll_solution,
          payroll_company: payment_company,
          line_type: line_type,
          ts_for_week_ending: ts_for_week_ending,
          submitted_week_end: this.company_records.end_date
        }
      }).then(response => {
        if (response.data !== "") {
          this.download_file(response.data, ts_info.company_name, 'additions invoice', vat, short_site_name);
        }
      });
    },

    export_deductions_credit(ts_info, vat, order_jobs, line_type, short_site_name) {
      let payment_company = null;
      if (ts_info.payroll_trading_company === 'Genius Contracts Limited') {
        payment_company = 'contracts'
      }
      else if (ts_info.payroll_trading_company === 'Genius Payroll Limited') {
        payment_company = 'payroll'
      }

      let ts_record = this.ts_records[0];
      let ts_for_week_ending = [ts_record.for_work_end_week_date];

      return axios.get(this.crmApiPath + 'timesheet/submitted/export/deductions_credit', {
        params: {
          company_id: ts_info.id,
          invoice_type: ts_info.invoicing_type,
          sage_ref: ts_info.internal_finance_ref,
          vat: vat,
          sites: order_jobs,
          gm_solution: ts_info.payroll_solution,
          payroll_company: payment_company,
          line_type: line_type,
          ts_for_week_ending: ts_for_week_ending,
          submitted_week_end: this.company_records.end_date
        }
      }).then(response => {
        if (response.data !== "") {
          this.download_file(response.data, ts_info.company_name, 'credit note', vat, short_site_name, ts_info.invoicing_type);
        }
      });
    },

    download_file(file, client_name, invoice_type, vat, short_site_name, edc) {
      let file_name = '';
      if (invoice_type === 'vat - sites one line - plus additions' || invoice_type === 'vat - sites per line - plus additions'
          || invoice_type === 'vat - sites one line - extra additions' || invoice_type === 'vat - sites per line - extra additions') {
        file_name = '_INVOICE_';
      }
      else if (invoice_type === 'vat - sites - plus additions' || invoice_type === 'vat - sites - extra additions') {
        file_name = '_INVOICE_SITES_';
      }
      else if (invoice_type === 'sites') {
        file_name = '_' + short_site_name + '_SITES_';
      }
      else if (invoice_type === 'credit note') {
        if (edc === 'sites') {
          file_name = '_' + short_site_name + '_CREDIT_DEDUCTIONS_';
        }
        else {
          file_name = '_CREDIT_DEDUCTIONS_';
        }
      }
      else if (invoice_type === 'sites credit note') {
        file_name = '_SITES_CREDIT_DEDUCTIONS_';
      }
      else if (invoice_type === 'additions invoice') {
        file_name = '_' + short_site_name + '_ADDITIONS_INVOICE_';
      }
      let vat_text = '';
      if (vat === '20%') {
        vat_text = 'VAT_20_';
      }
      else if (vat === '20%_RC') {
        vat_text = 'VAT_20_Reverse_Charge_';
      }
      else if (vat === '5%') {
        vat_text = 'VAT_5_';
      }
      else if (vat === '5%_RC') {
        vat_text = 'VAT_5_Reverse_Charge_';
      }
      else if (vat === '0%') {
        vat_text = 'VAT_0_';
      }
      
      // console.log(invoice_type)
      // console.log(file);

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([file]));
      link.setAttribute('download', client_name + file_name + vat_text + this.$moment().format('DD-MM-YYYY') + '.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
    },

    // Download Validations ======================================================================

    excel_export() {
      this.e_export = true;
      let ts_for_week_ending = [], company_id = null;
      ts_for_week_ending.push(this.ts_records[0].for_work_end_week_date);
      company_id = this.company_records.company_info.id;
      
      axios.post(this.crmApiPath + 'timesheet/submitted/export/validation', {
        locations: this.locations,
        preview_rows: this.preview_rows,
        ts_for_week_ending: ts_for_week_ending,
        recruitment: this.recruitment,
        week: this.week,
        company_id: company_id
      }, {
        responseType: 'arraybuffer'
      }).then(res => {
        // console.log(res.data)
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Validation_TS_' + this.company_records.company_info.company_name + '-' + this.$moment().format('DD-MM-YYYY') + '.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.e_export = false;
      });
    },
    excel_add_ded_export() {
      this.ead_export = true;
      let ts_for_week_ending = [];
      for (const [date, ts] of Object.entries(this.ts_records)) {
        ts_for_week_ending.push(date);
      }
      axios.post(this.crmApiPath + 'timesheet/submitted/export/add_ded', {
        locations: this.locations,
        preview_rows: this.preview_rows,
        ts_for_week_ending: ts_for_week_ending,
        company_id: this.company_records.company_info.id
      }, {
        responseType: 'arraybuffer'
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Additions_Deductions_TS_' + this.ts_info.company_name + '-' + this.$moment().format('DD-MM-YYYY') + '.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.ead_export = false;
      });
    },
  }
}
$(document).ready(function () {

});
</script>

<style scoped lang="scss">
#historic_per_worker_day_table, #historic_per_worker_loc_table, #historic_per_location_table, #historic_works_completed_table {
  height:     auto;
  max-height: 750px;
  overflow-y: auto;

  td {
    position:    relative;
    height:      45px;
    line-height: 15px;
    padding:     0 0.3rem;

    .td_data_outer {
      height:   45px;
      display:  block;
      width:    100%;
      position: relative;
    }

    .td_data {
      position:  absolute;
      top:       50%;
      transform: translateY(-50%);
      width:     100%;
    }

    &.firstName {
      z-index: 81;
    }

    &.running_totals {
      z-index: 101;
    }

    &.days, &.additionsDesc, &.deductionsDesc {
      padding: 0;
    }

    &.releaseRetention, &.backNextWeek {
      font-size: 1.25rem;
      /*z-index:   27;*/
    }

    &.submitPayroll {
      font-size: 1.25rem;
    }
  }

  .firstName {
    min-width: 150px;
    position:  sticky;
    left:      0;
    z-index:   85;
    //background-color: rgba(lighten($bc_4, 35%), 1);
  }

  tfoot {
    position:   -webkit-sticky;
    position:   sticky;
    bottom:     0;
    left:       0;
    background: #666;
    z-index:    99;

    tr, td {
      position:   -webkit-sticky;
      position:   sticky;
      bottom:     0;
      left:       0;
      background: $white;
      z-index:    99;
    }

    td {
      padding: 0;
    }

    td > div {
      padding:       0 0.3rem;
      border-color:  darken($bc_1, 10%);
      border-width:  6px;
      border-style:  double;
      border-left:   none;
      border-right:  none;
      border-bottom: none;
      margin-bottom: 10px;
    }
  }
}

#company_information {
  position:         absolute;
  padding-right:    20px;
  background-color: $white;
  z-index:          899;

  .ci_label {
    display: inline-block;
    width:   190px;
  }
}

.preview_sites {
  height:         160px;
  min-width:      80px;
  white-space:    nowrap;
  vertical-align: inherit;
}

.preview_sites > div {
  //transform: translate(5px, 50px) rotate(295deg);
  transform: translate(15px, 50px) rotate(285deg);
  width:     40px;
}

.preview_sites > div > span {
  padding:     0 5px;
  width:       165px;
  display:     block;
  white-space: normal;
  line-height: 12px;
}

.preview_site_totals, .add_ded_total_columns {
  text-align: center;
}

th.add_ded_total_columns {
  z-index:   80;
  min-width: 150px;
}

.preview_workers {
  .card {
    .card-header {
      background-color: $card_header_background;
    }
  }
}

.submitted {
  td {
    background-color: lighten($green, 40%) !important;
  }
}

.timesheet_page {
  max-height: calc(100vh - 130px);
  overflow:   scroll;
  min-height: calc(100vh - 130px);

  .company_list {
    height:     calc(100vh - 130px);
    min-height: calc(100vh - 130px);
    max-height: calc(100vh - 130px);
    overflow:   scroll;
    display:    inline-block;
    width:      250px;
    border:     1px solid black;
    position:   absolute;

    .company_details {
      display:       flex;
      border-bottom: 1px solid $bc_5;

      &:last-of-type {
        border-bottom: none;
      }

      &:hover, &:focus, &:active, &:active:focus, &.active:focus,
      &.focus, &:active.focus, &.active.focus {
        background-color: lighten($bc_5, 15%);
        cursor:           pointer;
      }

      .company {
        display:  inline-block;
        width:    224px;
        padding:  5px;
        position: relative;

        &.exported_green {
          background: lighten(lightgreen, 10%);
        }

        &.exported_amber{
          background: #f6993f;
        }

        &:before {
          content:      "";
          position:     absolute;
          right:        0;
          top:          5px;
          width:        30px;
          border-right: 1px solid $bc_5;
          bottom:       5px;
        }
      }

      .chevron {
        justify-content: center;
        align-content:   center;
        flex-direction:  column;
        display:         flex;
        text-align:      center;
        width:           25px;
        align-items:     center;

        &.inner_chevron_green {
          //position: absolute;
          background: lightgreen;
          padding:    5px;
        }

        &.inner_chevron_amber {
          //position: absolute;
          background: lighten(#FFBF00, 20%);
          padding:    5px;
        }
      }

      .company, .chevron {
        vertical-align: middle;
      }
    }
  }

  .timesheet_info {
    display:       inline-block;
    //width:        calc(100% - 260px);
    padding-left:  270px;
    padding-right: 15px;
    width:         100%;

    .timesheet_records {
      display:       inline-block;
      width:         200px;
      padding-right: 10px;
      border-right:  1px solid $bc_5;
      max-height:    420px;
      overflow:      scroll;
    }

    .timesheet_record_info {
      display: inline-block;
      width:   calc(100% - 210px);
    }

    .timesheet_records, .timesheet_record_info {
      vertical-align: top;
    }
  }

  .company_list, .timesheet_info {
    vertical-align: top;
  }

}

.tsre {
  display: inline-block;

  .tsre_card {
    margin:     5px;
    height:     initial;
    border:     3px solid;
    padding:    0;
    text-align: right;

    &.complete {
      background:   $white;
      border-color: $green;

      .tsre_week {
        color: $green;
      }

      .tsre_ce {
        background: $green;
      }
    }

    &.not_complete {
      background:   $white;
      border-color: $red;

      .tsre_week {
        color: $red;
      }

      .tsre_ce {
        background: $red;
      }
    }

    .tsre_ce {
      display:        inline-block;
      text-align:     left;
      padding:        5px 10px;
      vertical-align: middle;
      color:          $white;
    }

    .tsre_week {
      text-align:     left;
      font-weight:    bold;
      max-width:      205px;
      display:        inline-block;
      padding:        5px;
      vertical-align: middle;
    }

    &:hover, &:focus, &:active:focus, &:active, &:target {
      &.complete {
        background:   $green;
        border-color: darken($green, 5%);

        .tsre_week {
          color: $white;
        }
      }

      &.not_complete {
        background:   $red;
        border-color: darken($red, 5%);

        .tsre_week {
          color: $white;
        }
      }
    }
  }
}
</style>
